/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentPathParams,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentQueryParams,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment400,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment401,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment500,
} from "../../types/individualPaymentInvoicesController/PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment } from "../../clients/individualPaymentInvoicesController/postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment.ts";

export const postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentMutationKey =
  () =>
    [
      {
        url: "/api/v1/individualpayment/parcels/:parcelId/invoice-future-payment",
      },
    ] as const;

export type PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentMutationKey =
  ReturnType<
    typeof postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentMutationKey
  >;

export function postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentMutationKey();
  return mutationOptions<
    PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment400
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment401
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentPathParams["parcelId"];
      params?: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentQueryParams;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ parcelId, params }) => {
      return postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment(
        parcelId,
        params,
        config,
      );
    },
  });
}

/**
 * @description Marca a antecipação de emissão de NF (data de hoje, corpo e usuário); e-mail opcional gravado. O envio do e-mail é feito pela camada de notificação. Migrado do legado IndividualPayment/InvoiceFuturePayment. **(Requer Authorization para autenticação)**
 * @summary Antecipa a emissão da nota fiscal no pagamento futuro (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/invoice-future-payment}
 */
export function usePostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment400
        | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment401
        | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentPathParams["parcelId"];
        params?: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentQueryParams;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentMutationKey();

  const baseOptions =
    postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment400
        | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment401
        | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentPathParams["parcelId"];
        params?: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentQueryParams;
      },
      TContext
    >;

  return useMutation<
    PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment400
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment401
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentPathParams["parcelId"];
      params?: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentQueryParams;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment400
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment401
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentPathParams["parcelId"];
      params?: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentQueryParams;
    },
    TContext
  >;
}
